import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { CaretDown } from '@phosphor-icons/react';

export const Accordion = AccordionPrimitive.Root;

export function AccordionItem({
  className = '',
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item> & {
  className?: string;
}) {
  return (
    <AccordionPrimitive.Item
      className={`accordion-item ${className}`}
      {...props}
    />
  );
}

export function AccordionTrigger({
  className = '',
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
  className?: string;
}) {
  return (
    <AccordionPrimitive.Header>
      <AccordionPrimitive.Trigger
        className={`accordion-trigger ${className}`}
        {...props}
      >
        {children}
        <CaretDown className="accordion-chevron" aria-hidden />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

export function AccordionContent({
  className = '',
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content> & {
  className?: string;
}) {
  return (
    <AccordionPrimitive.Content
      className={`accordion-content ${className}`}
      {...props}
    >
      <div className="accordion-content__inner">{children}</div>
    </AccordionPrimitive.Content>
  );
}
